import {
	SET_FILTER,
	QR_LIST_REQUESTING,
	QR_LIST_SUCCESS,
	QR_LIST_ERROR,
	DISABLED_QR_LIST_REQUESTING,
	DISABLED_QR_LIST_SUCCESS,
	DISABLED_QR_LIST_ERROR,
	QR_DETAIL_REQUESTING,
	QR_DETAIL_SUCCESS,
	QR_DETAIL_ERROR,
	GET_OTP,
	GET_OTP_SUCCESS,
	GET_OTP_ERROR,
	DELETE_NOTIFICATION_RECEIVER,
	DELETE_NOTIFICATION_RECEIVER_SUCCESS,
	DELETE_NOTIFICATION_RECEIVER_ERROR,
	VERIFY_OTP,
	VERIFY_OTP_SUCCESS,
	VERIFY_OTP_ERROR,
	CLEAR_OTP,
	DOWNLOAD_QR,
	DOWNLOAD_QR_SUCCESS,
	DOWNLOAD_QR_ERROR,
	RESET_QR,
	TERMINAL_LIST_REQUESTING,
	TERMINAL_LIST_SUCCESS,
	TERMINAL_LIST_ERROR,
	TOTAL_TERMINAL_LIST_SUCCESS,
	TOTAL_TERMINAL_LIST_REQUESTING,
} from './types';

export const initialState = {
	qrList: {
		loading: true,
		start: 0,
		limit: 100,
		hasNextPage: false,
		currentPage: 1,
		list: [],
		totalList: [],
		loadTotalData: false,
		error: undefined,
	},
	disabledQrList: {
		loading: true,
		start: 0,
		limit: 100,
		hasNextPage: false,
		currentPage: 1,
		data: [],
		error: undefined,
	},
	selectedQR: {
		loading: true,
		notificationReceiver: [],
	},
	getOTP: { loading: true, otpRequired: false },
	verifyOTP: { loading: true },
	downloadQR: { loading: false },
	deleteNotificationReceiver: { loading: false },
	filters: {},
	terminalList: {
		loading: false,
		data: undefined,
		error: undefined,
		totalListLoading: false,
		totalList: [],
	},
};

function getQRList(state = initialState, action) {
	switch (action.type) {
		case SET_FILTER:
			return {
				...state,
				filters: action.filters.loadTotalData ? null : action.filters,
			};
		case QR_LIST_REQUESTING:
			return {
				...state,
				qrList: {
					...state.qrList,
					list: [],
					loading: true,
					totalList:
						action.payload.start === 0 ? [] : [...state.qrList.totalList],
					loadTotalData: action.payload.loadTotalData,
					error: undefined,
				},
			};
		case QR_LIST_SUCCESS:
			if (state.qrList.loadTotalData) {
				return {
					...state,
					qrList: {
						...state.qrList,
						list: [],
						totalList: [...state.qrList.totalList, ...action.data.data],
						loading: false,
						error: undefined,
						currentPage: action.data.currentPage,
						hasNextPage: action.data.hasNextPage,
						start: action.data.start,
					},
				};
			}
			return {
				...state,
				qrList: {
					...state.qrList,
					list: action.data.data,
					loading: false,
					error: undefined,
					currentPage: action.data.currentPage,
					hasNextPage: action.data.hasNextPage,
					start: action.data.start,
				},
			};

		case QR_LIST_ERROR:
			return {
				...state,
				qrList: {
					...state.qrList,
					error: action.error,
					loading: false,
				},
			};

		case DISABLED_QR_LIST_REQUESTING:
			return {
				...state,
				disabledQrList: {
					...state.disabledQrList,
					list: [],
					loading: true,
					error: undefined,
				},
			};
		case DISABLED_QR_LIST_SUCCESS:
			return {
				...state,
				disabledQrList: {
					...state.disabledQrList,
					list: action.data.data,
					loading: false,
					error: undefined,
					currentPage: action.data.currentPage,
					start: action.data.start,
				},
			};

		case DISABLED_QR_LIST_ERROR:
			return {
				...state,
				disabledQrList: {
					...state.disabledQrList,
					error: action.error,
					loading: false,
				},
			};

		case QR_DETAIL_REQUESTING:
			return {
				...state,
				selectedQR: {
					...state.selectedQR,
					loading: true,
				},
			};

		case QR_DETAIL_SUCCESS:
			return {
				...state,
				selectedQR: {
					...state.selectedQR,
					qrCodeId: action.data.id,
					qrText: action.data.data.qrText,
					notificationReceiver: action.data.mapping.notificationReceiver,
					storeName:
						action.data.mapping.store && action.data.mapping.store.displayName
							? action.data.mapping.store.displayName
							: 'NA',
					terminalName:
						action.data.mapping.terminal && action.data.mapping.terminal.name
							? action.data.mapping.terminal.name
							: 'NA',
					merchantName: action.data.mapping.merchant.displayName,
					loading: false,
					error: undefined,
				},
			};

		case QR_DETAIL_ERROR:
			return {
				...state,
				selectedQR: {
					...state.selectedQR,
					error: action.error,
					loading: false,
				},
			};

		case GET_OTP:
			return {
				...state,
				getOTP: {
					...state.getOTP,
					loading: true,
				},
			};

		case GET_OTP_SUCCESS:
			return {
				...state,
				getOTP: {
					...state.getOTP,
					loading: false,
					error: undefined,
					message: action.data.message,
					status: action.data.status,
					token: action.data.token,
					expiry: action.data.expiry,
					otpRequired: action.otpRequired,
				},
			};

		case GET_OTP_ERROR:
			return {
				...state,
				getOTP: {
					...state.getOTP,
					loading: false,
					error: action.error,
				},
			};

		case VERIFY_OTP:
			return {
				...state,
				addNotificationReceiver: {
					...state.addNotificationReceiver,
					verifyOTP: {
						...state.verifyOTP,
						loading: true,
					},
				},
			};

		case VERIFY_OTP_SUCCESS:
			return {
				...state,
				addNotificationReceiver: {
					...state.addNotificationReceiver,
					verifyOTP: {
						...state.verifyOTP,
						loading: false,
						message: action.data.message,
						status: action.data.status,
					},
				},
			};

		case VERIFY_OTP_ERROR:
			return {
				...state,
				addNotificationReceiver: {
					...state.addNotificationReceiver,
					verifyOTP: {
						...state.verifyOTP,
						loading: false,
						error: action.error,
					},
				},
			};

		case CLEAR_OTP:
			return {
				...state,
				getOTP: { loading: false, otpRequired: false },
				verifyOTP: { loading: false },
			};

		case DOWNLOAD_QR:
			return {
				...state,
				downloadQR: { loading: true },
			};

		case DOWNLOAD_QR_SUCCESS:
			return {
				...state,
				downloadQR: { loading: false, error: undefined },
			};

		case DOWNLOAD_QR_ERROR:
			return {
				...state,
				downloadQR: { loading: false, error: action.error },
			};

		case DELETE_NOTIFICATION_RECEIVER:
			return {
				...state,
				deleteNotificationReceiver: {
					...state.deleteNotificationReceiver,
					loading: true,
				},
			};

		case DELETE_NOTIFICATION_RECEIVER_SUCCESS:
			return {
				...state,
				deleteNotificationReceiver: {
					...state.deleteNotificationReceiver,
					loading: false,
					message: action.data.message,
					status: action.data.status,
					error: undefined,
				},
			};

		case DELETE_NOTIFICATION_RECEIVER_ERROR:
			return {
				...state,
				deleteNotificationReceiver: {
					...state.deleteNotificationReceiver,
					loading: false,
					error: action.error,
				},
			};

		case TERMINAL_LIST_REQUESTING:
			return {
				...state,
				terminalList: {
					...state.terminalList,
					loading: true,
					data: undefined,
					error: undefined,
				},
			};
		case TERMINAL_LIST_SUCCESS:
			return {
				...state,
				terminalList: {
					...state.terminalList,
					data: action.data,
					totalList: action.data,
					loading: false,
					totalListLoading: false,
					error: undefined,
				},
			};

		case TOTAL_TERMINAL_LIST_REQUESTING:
			return {
				...state,
				terminalList: {
					...state.terminalList,
					totalListLoading: true,
					loading: false,
					data: undefined,
					error: undefined,
				},
			};

		case TOTAL_TERMINAL_LIST_SUCCESS:
			return {
				...state,
				terminalList: {
					...state.terminalList,
					data: action.data,
					loading: false,
					totalListLoading: false,
					totalList: [...state.terminalList.totalList, ...action.data],
					error: undefined,
				},
			};

		case TERMINAL_LIST_ERROR:
			return {
				...state,
				terminalList: {
					...state.terminalList,
					error: action.error,
					totalListLoading: false,
					loading: false,
					data: undefined,
				},
			};

		case RESET_QR:
			return initialState;

		default:
			return state;
	}
}

export default getQRList;
